import { type DocModel } from 'src/@types/docs';
import { PATH_DASHBOARD } from 'src/Router/paths';
import { NavItem } from 'src/features/Navbar/NavItem';
import { DocAvatar } from 'src/features/doc/DocAvatar';
import type { TreeItem } from './types';

type Props = {
  node: TreeItem;
  isOpen: boolean;
  onToggle: (_id: DocModel['id']) => void;
};

export const DocsFavoritedItem = ({ node, onToggle, isOpen }: Props) => {
  const docUrl = PATH_DASHBOARD.docs.view(node.id as string);

  const handleToggle = () => {
    onToggle(node.id);
  };

  return (
    <NavItem
      path={docUrl}
      depth={1}
      isTreeView
      actionAlwaysVisible
      hasSubNav={node.data?.hasChildren}
      toggleSubNav={handleToggle}
      isSubNavOpen={isOpen}
      icon={
        <DocAvatar
          key={node.id}
          icon={node.data?.icon?.value}
          starred={node.data?.starred}
        />
      }
      sx={{
        marginBottom: 0.5,
      }}
    >
      {node.text}
    </NavItem>
  );
};
